import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-estimate-tab-box',
  templateUrl: './estimate-tab-box.component.html',
  styleUrls: ['./estimate-tab-box.component.css']
})
export class EstimateTabBoxComponent {
  historyState: any;
  @Input() isLoader: boolean = false;
  @Output() saveBtnClick = new EventEmitter<void>();
  @Output() closeBtnClick = new EventEmitter<void>();

  ngOnInit(): void {
    this.historyState = history.state;
  }
  saveButtonClick() {
    this.saveBtnClick.emit();
  }
  closeButtonOnClick() {
    this.closeBtnClick.emit();
  }

}
